export default __webpack_public_path__ + "static/media/0750128762657L.bc15c600.jpg";